import React from "react";
import styled from "styled-components";
import { AboutItem } from "./AboutItem";
import { getYears } from "../../utils/getYears";

const aboutData = [
  {
    title: "Специализация",
    text: "Frontend разработка",
  },
  {
    title: "Возраст",
    text: getYears("30.09.2004"),
  },
  {
    title: "Занимаюсь программированием",
    text: "3 года",
  },
  {
    title: "В веб-программировании",
    text: "> 1 года",
  },
  {
    title: "Технологии",
    text: "HTML, CSS, Javascript, React",
  },
];

const StyledAboutBox = styled.div`
  margin: ${({ margin }) => margin || 0};
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const AboutBox = ({ ...props }) => {
  return (
    <StyledAboutBox {...props}>
      {aboutData.map((aboutItem, delay) => (
        <AboutItem
          key={aboutItem.title}
          title={aboutItem.title}
          text={aboutItem.text}
          animationDelay={delay}
        />
      ))}
    </StyledAboutBox>
  );
};
